// Surface/Subsea presentation accent (Support correction — Aug 2026, Item 6).
//
// Convention: Surface = amber, Subsea = blue. Reuses the app's existing
// operating-mode context (useStackMode) and its existing "offshore/subsea"
// blue (the same `sky` shade EnvIcon already uses for offshore wells) —
// no new colour-state mechanism, no new tokens.
//
// Presentation-only: swaps className strings / a CSS colour value based on
// the current stack mode. Nothing here touches data, schemas, or storage.

export function stackAccentClasses(stackMode) {
  const subsea = stackMode === "subsea";
  return {
    text:        subsea ? "text-sky-400"          : "text-amber-400",
    border40:    subsea ? "border-sky-500/40"      : "border-amber-500/40",
    border30:    subsea ? "border-sky-500/30"      : "border-amber-500/30",
    hoverBg10:   subsea ? "hover:bg-sky-500/10"    : "hover:bg-amber-500/10",
    hoverText:   subsea ? "hover:text-sky-400"     : "hover:text-amber-400",
  };
}

// Raw colour for inline `style={{ background/color: ... }}` usages that
// currently hardcode `var(--rs-amber)`. Falls back to the existing amber
// design token for Surface so nothing changes there.
export function stackAccentColor(stackMode) {
  return stackMode === "subsea" ? "#38bdf8" : "var(--rs-amber)";
}
